var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "130px",
    height: "130px",
    viewBox: "0 0 130 130",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_success") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-08",
    transform: "translate(-735.000000, -326.000000)",
    fill: "#95C11F"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(560.000000, 266.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_success",
    transform: "translate(175.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.200000003,
    cx: 65,
    cy: 65,
    r: 65
  }), /*#__PURE__*/React.createElement("g", {
    id: "check-circle-1",
    transform: "translate(35.000000, 35.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5,42.4975 C27.2175,42.4975 26.94,42.4 26.72,42.225 L14.22,32.225 C13.6825,31.7925 13.595,31.005 14.025,30.4675 C14.2625,30.1675 14.62,29.9975 15,29.9975 C15.2825,29.9975 15.56,30.095 15.78,30.27 L27.265,39.4575 L43.995,16.755 C44.2275,16.4375 44.6025,16.2475 45,16.2475 C45.27,16.2475 45.525,16.3325 45.7425,16.4925 C46.01,16.69 46.185,16.98 46.2375,17.31 C46.29,17.64 46.205,17.97 46.0075,18.24 L28.5075,41.99 C28.3075,42.2625 28,42.445 27.6625,42.4875 C27.61,42.495 27.555,42.4975 27.5,42.4975 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,59.9975 C13.4575,59.9975 0,46.54 0,29.9975 C0,13.455 13.4575,-0.0025 30,-0.0025 C46.5425,-0.0025 60,13.455 60,29.9975 C60,46.54 46.5425,59.9975 30,59.9975 Z M30,2.4975 C14.8375,2.4975 2.5,14.835 2.5,29.9975 C2.5,45.16 14.8375,57.4975 30,57.4975 C45.1625,57.4975 57.5,45.16 57.5,29.9975 C57.5,14.835 45.1625,2.4975 30,2.4975 Z",
    id: "Shape"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/icon_success.0ca35aa3c690ebeccedf4d021b005997.svg";
export { ForwardRef as ReactComponent };